import MundialRequestTask from "./MundialRequestTask";

export class TeamStatsTask extends MundialRequestTask {
  matchId: string;

  constructor(matchId: string) {
    super();
    this.matchId = matchId;
  }

  getUrl() {
    const baseUrl = this.getBaseUrl();
    return `${baseUrl}/matches/${this.matchId}/team-stats`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/TeamStatsTask.ts